const getTeamName = (teamId: string, teams: any): string => {
    return (
        teams.find((team: { key: string }) => team.key === teamId)?.name ||
        'Unknown'
    );
};

export default getTeamName;
